<template>
  <b-modal ref="modal" hide-footer centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <div class="modal-importar-sigtap__header">
        <h5 class="modal-title mb-0">Importar SIGTAP</h5>

        <div class="modal-importar-sigtap__actions">
          <modal-informacao
            :isIframe="true"
            urlIframe="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-4371"
          />

          <button
            type="button"
            class="close"
            aria-label="Close"
            :disabled="loading"
            @click="close()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </template>

    <div class="form-group">
      <label>rl_procedimento_registro</label>
      <input
        type="file"
        class="form-control"
        accept=".txt,text/plain"
        @change="selecionarArquivo($event, 'rl_procedimento_registro')"
      />
    </div>

    <div class="form-group mt-3">
      <label>rl_procedimento_detalhe</label>
      <input
        type="file"
        class="form-control"
        accept=".txt,text/plain"
        @change="selecionarArquivo($event, 'rl_procedimento_detalhe')"
      />
    </div>

    <div class="d-flex justify-content-end mt-4" style="gap: 10px">
      <button
        type="button"
        class="btn btn-secondary"
        :disabled="loading"
        @click="fechar"
      >
        Cancelar
      </button>

      <button
        type="button"
        class="btn btn-primary"
        :disabled="loading"
        @click="importar"
      >
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm me-2"
        ></span>

        {{ loading ? 'Importando...' : 'Importar' }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import ModalInformacao from '@/components/ModalInformacao.vue'

export default {
  name: 'ModalImportarSigtap',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ModalInformacao,
  },

  data() {
    return {
      arquivos: {
        rl_procedimento_registro: null,
        rl_procedimento_detalhe: null,
      },
    }
  },

  methods: {
    /**
     * Abre o modal de importação do SIGTAP.
     *
     * @returns {void}
     */
    abrir() {
      this.limparArquivos()
      this.$refs.modal.show()
    },

    /**
     * Fecha o modal de importação do SIGTAP.
     *
     * @returns {void}
     */
    fechar() {
      this.$refs.modal.hide()
    },

    /**
     * Limpa os arquivos selecionados no modal.
     *
     * @returns {void}
     */
    limparArquivos() {
      this.arquivos = {
        rl_procedimento_registro: null,
        rl_procedimento_detalhe: null,
      }
    },

    /**
     * Seleciona um arquivo do SIGTAP.
     *
     * @param {Event} event Evento do input file
     * @param {String} tipoArquivo Tipo do arquivo SIGTAP
     * @returns {void}
     */
    selecionarArquivo(event, tipoArquivo) {
      const arquivo = event.target.files[0]

      if (!arquivo) {
        this.arquivos[tipoArquivo] = null
        return
      }

      const extensao = arquivo.name.split('.').pop().toLowerCase()

      if (extensao !== 'txt') {
        this.$toast?.error?.('Selecione apenas arquivos .txt.')
        event.target.value = ''
        this.arquivos[tipoArquivo] = null
        return
      }

      this.arquivos[tipoArquivo] = arquivo
    },

    /**
     * Emite os arquivos selecionados para o componente pai.
     *
     * @returns {void}
     */
    importar() {
      if (!this.arquivos.rl_procedimento_registro) {
        this.$toast?.error?.('Selecione o arquivo rl_procedimento_registro.')
        return
      }

      if (!this.arquivos.rl_procedimento_detalhe) {
        this.$toast?.error?.('Selecione o arquivo rl_procedimento_detalhe.')
        return
      }

      this.$emit('importar', this.arquivos)
    },
  },
}
</script>

<style scoped lang="scss">
.modal-importar-sigtap__header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-importar-sigtap__actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.close {
  border: 0;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  padding: 0;
  margin: 0;
}
</style>
